import React, { useMemo } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { formatUTCDate } from '../../utils/dateUtils';

interface LastContactDateProps { 
  date: string | null;
  type: 'email' | 'manual' | null;
}

export default function LastContactDate({ date, type }: LastContactDateProps) {
  if (!date) {
    return <span className="text-gray-400">No communications</span>;
  }

  const formattedDate = useMemo(() => {
    const contactDate = new Date(date);
    return {
      full: formatUTCDate(date),
      relative: formatDistanceToNow(contactDate, { addSuffix: true })
    };
  }, [date]);

  return (
    <span title={formattedDate.full}>
      {formattedDate.relative}
      {type && <span className="text-xs ml-1">({type})</span>}
    </span>
  );
}